import script from "./ShareSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareSheet.vue?vue&type=script&setup=true&lang=js"

import "./ShareSheet.vue?vue&type=style&index=0&id=2d27bcbc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d27bcbc"]])

export default __exports__